var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessaging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1953 10.8821C11.1953 10.1783 11.7219 9.63071 12.3986 9.63071H24.3418C25.0185 9.63071 25.5451 10.1783 25.5451 10.8821V18.3284C25.5451 19.0323 25.0185 19.5798 24.3418 19.5798H23.6318V23.3108H23.1534H23.1086L22.0249 22.1915C22.0253 22.1902 22.0251 22.1888 22.0249 22.1874C22.0247 22.186 22.0245 22.1847 22.0249 22.1837C22.1325 21.9178 22.1968 21.6263 22.1968 21.3209V13.3616C22.1968 12.1301 21.2285 11.1231 20.0443 11.1231H11.1953V10.8821ZM6.41211 13.3616C6.41211 12.6641 6.93717 12.118 7.60792 12.118H20.0443C20.7151 12.118 21.2401 12.6641 21.2401 13.3616V21.3209C21.2401 22.0185 20.7151 22.5646 20.0443 22.5646H12.6303C12.5038 22.5656 12.3829 22.6187 12.294 22.7123L8.84857 26.2955H8.80373H8.3254V22.5646H7.60792C6.93717 22.5646 6.41211 22.0185 6.41211 21.3209V13.3616Z",
    fill: "#4079F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessaging);
export default __webpack_public_path__ + "static/media/messaging.f6f5fcaa9b15a22b5217508132019da0.svg";
export { ForwardRef as ReactComponent };